import { render } from "./GoodsListCate3.vue?vue&type=template&id=5c9c7800&scoped=true"
import script from "./GoodsListCate3.vue?vue&type=script&lang=js"
export * from "./GoodsListCate3.vue?vue&type=script&lang=js"

import "./GoodsListCate3.vue?vue&type=style&index=0&id=5c9c7800&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9c7800"]])

export default __exports__